import { moveElement } from '@common/neo.tax';
import isoCountries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

// Register the desired languages to minimize file size
isoCountries.registerLocale(enLocale);

/**
 * { 'AF': 'Afghanistan', 'AX': 'Åland Islands', 'AL': 'Albania', ... }
 */
const countryNamesDict = isoCountries.getNames('en', { select: 'official' });

export const COUNTRY_DICT_ALPHA2 = Object.keys(countryNamesDict).reduce(
  (acc, codeAlpha2) => {
    acc[codeAlpha2] = {
      name: countryNamesDict[codeAlpha2],
      codeAlpha2,
      codeAlpha3: isoCountries.toAlpha3(codeAlpha2),
    };
    return acc;
  },
  {} as Record<string, { name: string; codeAlpha2: string; codeAlpha3: string }>,
);

export const COUNTRY_DICT_ALPHA3 = Object.keys(countryNamesDict).reduce(
  (acc, codeAlpha2) => {
    const codeAlpha3 = isoCountries.toAlpha3(codeAlpha2);
    acc[codeAlpha3] = {
      name: countryNamesDict[codeAlpha2],
      codeAlpha2,
      codeAlpha3,
    };
    return acc;
  },
  {} as Record<string, { name: string; codeAlpha2: string; codeAlpha3: string }>,
);

const countryOptions = Object.values(COUNTRY_DICT_ALPHA2).map((country) => ({
  ...country,
  imageSrc: `https://flagcdn.com/w40/${country.codeAlpha2.toLowerCase()}.png`,
  imageSrcSet: `https://flagcdn.com/w80/${country.codeAlpha2.toLowerCase()}.png 2x`,
}));
export const COUNTRY_OPTIONS = moveElement(
  countryOptions,
  countryOptions.findIndex((c) => c.codeAlpha2 === 'US'),
  0,
);

const convertUnofficialCountryToAlpha2 = (countryNameOrCode: string): string => {
  switch (countryNameOrCode.toLowerCase()) {
    case 'united states':
    case 'united states of america':
      return 'US';
    case 'uk':
    case 'united kingdom':
    case 'united kingdom of great britain and northern ireland':
      return 'GB';
    default:
      return isoCountries.getAlpha2Code(countryNameOrCode, 'en');
  }
};

export const getCountryCodeAlpha2 = (countryNameOrCode: string): string | undefined => {
  if (countryNameOrCode in COUNTRY_DICT_ALPHA2) {
    return countryNameOrCode.toLowerCase();
  }
  if (countryNameOrCode in COUNTRY_DICT_ALPHA3) {
    return isoCountries.toAlpha2(countryNameOrCode).toLowerCase();
  }

  return convertUnofficialCountryToAlpha2(countryNameOrCode)?.toLowerCase();
};
